import Toast from "components/cms/Toast";
import PricingStack from "components/cms/PricingStack";
import useCmsPage from "hooks/useCmsPage";
import {
  addPricingPage,
  getPricingPage,
  preparePricingPage,
  updatePricingPage,
} from "api/pricingpage";
import { emptyPricing } from "utils/defaults";

export default function PricingPage() {
  const {
    form,
    setField,
    frMap,
    exists,
    loading,
    toast,
    setToast,
    save,
    saveSection,
    savingSection,
    isSectionDirty,
  } = useCmsPage({
    load: getPricingPage,
    create: addPricingPage,
    update: updatePricingPage,
    empty: emptyPricing,
    mapResponse: (res) => res.data?.data,
    prepare: preparePricingPage,
  });

  const savePricing = (sectionId, keys) => {
    if (!exists) {
      save();
      return;
    }
    saveSection(sectionId, keys);
  };

  if (loading) {
    return <p className="mt-5 text-gray-600">Loading Fixed Pricing…</p>;
  }

  return (
    <div className="mt-3">
      <Toast toast={toast} onClose={() => setToast(null)} />
      {!exists ? (
        <p className="mb-3 text-sm text-gray-500">
          Fixed pricing is not saved yet. Fill the sections and click Save to
          create this page.
        </p>
      ) : null}
      <PricingStack
        heading="Fixed pricing page"
        description="/pricing"
        idPrefix="pricing-fixed"
        form={form}
        setField={setField}
        frMap={frMap}
        exists={exists}
        savePricing={savePricing}
        savingSection={savingSection}
        isSectionDirty={isSectionDirty}
      />
    </div>
  );
}
